// 對應 CustomizeModel.FormType的列舉
export class InstallPositionStatus {
  static get NotApplied () {
    return 0
  }
  static get Pending () {
    return 1
  }
  static get Approved () {
    return 2
  }
  static get Rejected () {
    return 3
  }
  static InstallPositionStatusName (installPositionStatus) {
    let tmpType = parseInt(installPositionStatus)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 0:
        name = '單據尚未確認'
        break
      case 1:
        name = '待核准'
        break
      case 2:
        name = '核准'
        break
      case 3:
        name = '拒絕'
        break
    }
    return name
  }
}
